var _style, _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgDocument",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgDocument{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    className: "svgDocument svgBase svgHover svgSelect",
    d: "M4.2,8.2h7.6c0.1,0,0.3-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.3-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.3,0.1-0.3,0.1C3.8,7.5,3.7,7.6,3.7,7.7C3.7,8,3.9,8.2,4.2,8.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    className: "svgDocument svgBase svgHover svgSelect",
    d: "M4.2,11.5h7.6c0.1,0,0.3-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.3-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3C3.7,11.2,3.9,11.5,4.2,11.5 C4.2,11.5,4.2,11.5,4.2,11.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    className: "svgDocument svgBase svgHover svgSelect",
    d: "M4.2,4.9h7.6c0.1,0,0.3-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.3-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1H4.2c-0.3,0-0.5,0.2-0.5,0.5C3.7,4.7,3.9,4.9,4.2,4.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    className: "svgDocument svgBase svgHover svgSelect",
    d: "M13.3,15.7H2.7c-0.8,0-1.4-0.6-1.4-1.4V1.7c0-0.8,0.6-1.4,1.4-1.4h10.6c0.8,0,1.4,0.6,1.4,1.4 v12.5C14.7,15,14.1,15.7,13.3,15.7z M2.7,1.3c-0.2,0-0.4,0.2-0.4,0.4v12.5c0,0.2,0.2,0.4,0.4,0.4h10.6c0.2,0,0.4-0.2,0.4-0.4V1.7 c0-0.2-0.2-0.4-0.4-0.4L2.7,1.3z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.b76b5c88.svg";
export { ForwardRef as ReactComponent };